import { render, staticRenderFns } from "./TopicReport.vue?vue&type=template&id=776ea8ca&scoped=true"
import script from "./TopicReport.vue?vue&type=script&lang=js"
export * from "./TopicReport.vue?vue&type=script&lang=js"
import style0 from "./TopicReport.vue?vue&type=style&index=0&id=776ea8ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776ea8ca",
  null
  
)

export default component.exports